import { createContext, useEffect, useState } from "react";
import { UserType } from "../../types/user";
import SessionStorage from "../../utils/SessionStorage";

interface IDefaultValue {
  isLoggedin: boolean | null;
  user: UserType | null;
  token: null | string;
  login: Function;
  logout: Function;
}

const defaultValue: IDefaultValue = {
  isLoggedin: null,
  user: null,
  token: null,
  login: (token: string, user: UserType) => {},
  logout: () => {},
};
export const AuthContext = createContext<IDefaultValue>(defaultValue);

const AuthContextProvider = (props: { children: React.ReactNode }) => {
  const [isLoggedin, setIsLoggedin] = useState<boolean | null>(null);
  const [user, setUser] = useState<UserType | null>(null);
  const [token, setToken] = useState<string | null>(null);

  const login = (token: string, user: UserType) => {
    SessionStorage.saveAuthData({ user, token });
    setIsLoggedin(true);
    setUser(user);
    setToken(token);
  };

  const logout = () => {
    SessionStorage.deleteAuthData();
    setIsLoggedin(false);
    setUser(null);
    setToken(null);
  };

  useEffect(() => {
    const userData = SessionStorage.retrieveAuthData();
    if (userData) {
      setIsLoggedin(true);
    }
  });
  return (
    <AuthContext.Provider
      value={{
        isLoggedin,
        user,
        token,
        login,
        logout,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
